import isEqual from 'lodash/isEqual'
import * as React from 'react'
import ProductFruits from 'react-product-fruits'

import { hasText } from './utils/helpers'
import { ZentakeContext } from './utils/ZentakeContext'

function ProductFruitsIntegrationFn({
  username,
  email,
  firstname,
  lastname,
  signUpAt,
  extraProps,
}) {
  const userInfo = {
    username,
    email,
    firstname,
    lastname,
    signUpAt: hasText(signUpAt) ? new Date(signUpAt).toISOString() : undefined,
    props: extraProps,
  }

  if (!hasText(userInfo.username)) {
    return null
  }

  return (
    <ProductFruits language="en" projectCode="sIsqPo53E2phNdOZ" {...userInfo} />
  )
}

function arePropsEqual(p, n) {
  return (
    p.username === n.username &&
    p.email === n.email &&
    p.firstname === n.firstname &&
    p.lastname === n.lastname &&
    p.signUpAt === n.signUpAt &&
    isEqual(p.extraProps, n.extraProps)
  )
}

const ProductFruitsIntegrationMemo = React.memo(
  ProductFruitsIntegrationFn,
  arePropsEqual
)

function ProductFruitsIntegration() {
  const { userDetails } = React.useContext(ZentakeContext)

  return (
    <ProductFruitsIntegrationMemo
      email={userDetails?.email}
      extraProps={{
        active: userDetails?.subscription?.plan?.active,
        subscriptionName: userDetails?.subscription?.plan?.product?.name,
      }}
      firstname={userDetails?.first_name}
      lastname={userDetails?.last_name}
      signUpAt={userDetails?.date_joined}
      username={userDetails?.username}
    />
  )
}

export default ProductFruitsIntegration
